/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Save_Acc_TypeInputs */

const en_action_save_acc_type = /** @type {(inputs: Action_Save_Acc_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Account Type`)
};

const es_action_save_acc_type = /** @type {(inputs: Action_Save_Acc_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar Tipo de Cuenta`)
};

const fr_action_save_acc_type = /** @type {(inputs: Action_Save_Acc_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le type de compte`)
};

const de_action_save_acc_type = /** @type {(inputs: Action_Save_Acc_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontotyp speichern`)
};

const id_action_save_acc_type = /** @type {(inputs: Action_Save_Acc_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan Jenis Akun`)
};

/** @type {(inputs: Action_Save_Acc_TypeInputs) => LocalizedString} */
const ja_action_save_acc_type = en_action_save_acc_type;

/** @type {(inputs: Action_Save_Acc_TypeInputs) => LocalizedString} */
const zh_action_save_acc_type = en_action_save_acc_type;

/** @type {(inputs: Action_Save_Acc_TypeInputs) => LocalizedString} */
const ar_action_save_acc_type = en_action_save_acc_type;

/** @type {(inputs: Action_Save_Acc_TypeInputs) => LocalizedString} */
const it_action_save_acc_type = en_action_save_acc_type;

/** @type {(inputs: Action_Save_Acc_TypeInputs) => LocalizedString} */
const ru_action_save_acc_type = en_action_save_acc_type;

/** @type {(inputs: Action_Save_Acc_TypeInputs) => LocalizedString} */
const pt_action_save_acc_type = en_action_save_acc_type;

/** @type {(inputs: Action_Save_Acc_TypeInputs) => LocalizedString} */
const ko_action_save_acc_type = en_action_save_acc_type;

/**
* | output |
* | --- |
* | "Save Account Type" |
*
* @param {Action_Save_Acc_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_save_acc_type = /** @type {((inputs?: Action_Save_Acc_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Save_Acc_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_save_acc_type(inputs)
	if (locale === "es") return es_action_save_acc_type(inputs)
	if (locale === "fr") return fr_action_save_acc_type(inputs)
	if (locale === "de") return de_action_save_acc_type(inputs)
	if (locale === "ja") return ja_action_save_acc_type(inputs)
	if (locale === "zh") return zh_action_save_acc_type(inputs)
	if (locale === "ar") return ar_action_save_acc_type(inputs)
	if (locale === "id") return id_action_save_acc_type(inputs)
	if (locale === "it") return it_action_save_acc_type(inputs)
	if (locale === "ru") return ru_action_save_acc_type(inputs)
	if (locale === "pt") return pt_action_save_acc_type(inputs)
	return ko_action_save_acc_type(inputs)
});